import React from "react";


export function ListDalleMnh(dalleMNX) {





    return (
        <div className="scrollable-panel-content" >
            <div className="outer-div">
                {dalleMNX.dalleMNX.map((item, index) => (


                    <div className="liste_dalle inner-div" key={index}>
                            <a
                                href={item.mnh.url}
                                style={{lineHeight:1.1}}
                            >
                                {item.mnh.name}
                            </a>
                    </div>


                ))}
            </div>
        </div>
    );
}